<template>
  <div class="flex flex-row gap-16 flex-wrap">
    <PdpChargingInfo />
    <PdpEnergylabelEnergyLabelButton />
  </div>
</template>
<script setup lang="ts"></script>
